import type { FC } from 'react';

import type { AlertReset } from '@/alerts/entities/alert-reset';
import {
  Dialog,
  DialogBody,
  DialogDescription,
  DialogTitle,
} from '@/components/ui/dialog';
import { formatDate } from '@/utils/format/date';

export type AlertResetsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  alertResets: AlertReset[];
};

export const AlertResetsModal: FC<AlertResetsModalProps> = ({
  isOpen,
  onClose,
  alertResets,
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle className="text-lg font-semibold">
        Alert Resets Due to Maintenance
      </DialogTitle>
      <DialogBody className="max-w-2xl">
        <DialogDescription className="mb-4 text-sm text-gray-600">
          The following alerts were reset during the selected timeframe due to
          successful maintenance:
        </DialogDescription>
        <div className="max-h-64 space-y-2 overflow-y-auto">
          {alertResets?.map((reset: AlertReset) => (
            <div
              key={reset.fullFrontendId}
              className="rounded border bg-gray-50 px-3 py-2 font-mono text-sm"
            >
              <div className="font-medium">{reset.fullFrontendId}</div>
              <div className="mt-1 text-xs text-gray-500">
                Reset at: {formatDate(reset.resetAtTime)}
              </div>
            </div>
          ))}
        </div>
      </DialogBody>
    </Dialog>
  );
};
